<ng-container *transloco="let t">
  <pxw-modal-dialog
    #establishmentClosedDialog
    [title]="t('establishmentClosedDialog.title')"
    type="alert"
  >
    <pxw-icon icon="clock" />
    <ng-template #modalContent>
      <p>{{ t('establishmentClosedDialog.description') }}</p>

      <pxw-alert type="warning" [withoutIcon]="true">
        <pxw-working-hours-message-details [workingDays]="workingDays()" />
      </pxw-alert>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
